module.exports = __webpack_public_path__ + "static/img/gif.184ffa3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/bodyfriend/gif.gif
// module id = qovj
// module chunks = 1